import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'dictionaryHasValue',
})
export class DictionaryHasValuePipe implements PipeTransform {
  transform(obj: Object) {
    return Object.values(obj).some(
      (value) => (Array.isArray(value) && value.length) || (!Array.isArray(value) && value !== undefined)
    );
  }
}
